import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ExpansionPanelComponent } from "@hermes/aphrodite/expansion-panel";
import { LayoutStateModule } from "@hermes/aphrodite/layout";
import { CurrencyModule } from "@hermes/aphrodite/price";
import {
    svgArrowLeft,
    svgArrowRight,
    svgCheck,
    svgCrossRounded,
    svgGridSquare,
    svgLivechat,
    SvgRegistryService,
    svgSquare,
} from "@hermes/aphrodite/svg";
import { LivechatDirectiveModule } from "@hermes/fragments/livechat-directive";
import { BackToGridService } from "@hermes/fragments/product-utils";
import { SeoLinksModule } from "@hermes/fragments/seo-links";
import {
    GridFilterBarComponent,
    GridPageModule as NewGridPageModule,
} from "@hermes/pages/grid-page";
import { AddToCartFacade } from "@hermes/states/add-to-cart";
import { ExternalLibraryFacade } from "@hermes/states/external-library";
import { GridFiltersStateModule } from "@hermes/states/grid-filters-state";
import { MenuStateModule } from "@hermes/states/menu";
import { UserStateModule } from "@hermes/states/user";
import { CMSService } from "@hermes/utils/services/api-clients";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { ImageUrlPipe } from "@hermes/utils-generic/pipes/image-url";
import { FocusService } from "@hermes/utils-generic/services/focus";
import { RouterServiceModule } from "@hermes/utils-generic/services/router";

import { GridPageComponent } from "./components/grid-page/grid-page.component";
import { GridFiltersModule } from "./grid-filters.module";
import { GridPageRoutingModule } from "./grid-page-routing.module";

@NgModule({
    imports: [
        CommonModule,
        CurrencyModule,
        GridPageRoutingModule,
        SeoLinksModule,
        GridFiltersModule,
        NewGridPageModule,
        LivechatDirectiveModule,
        LayoutStateModule,
        MenuStateModule,
        RouterServiceModule,
        ExpansionPanelComponent,
        UserStateModule,
        GridFiltersStateModule,
        GridFilterBarComponent,
        SrOnlyNoSnippetDirective,
    ],
    providers: [
        BackToGridService,
        CMSService,
        FocusService,
        ExternalLibraryFacade,
        AddToCartFacade,
        ImageUrlPipe,
    ],
    declarations: [GridPageComponent],
})
export class GridPageModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgCrossRounded,
            svgGridSquare,
            svgSquare,
            svgArrowLeft,
            svgArrowRight,
            svgCheck,
            svgLivechat,
        ]);
    }
}
